import { strings } from "../localization/LocalizedStrings";
import { ShelvingTheme } from "../hooks/shelvings";

const cedarImage = new URL("../images/shelvings/shelving_cedar.jpg", import.meta.url).href;
const oakImage = new URL("../images/shelvings/shelving_oak.jpg", import.meta.url).href;
const ebonyImage = new URL("../images/shelvings/shelving_ebony.jpg", import.meta.url).href;
const walnutImage = new URL("../images/shelvings/shelving_walnut.jpg", import.meta.url).href;
const blueImage = new URL("../images/shelvings/shelving_blue.jpg", import.meta.url).href;

export const ShelvingUtilities = {
  getThemeString: (theme: ShelvingTheme) => {
    switch (theme) {
      case "cedar":
        return strings.shelving_cedar;
      case "oak":
        return strings.shelving_oak;
      case "ebony":
        return strings.shelving_ebony;
      case "walnut":
        return strings.shelving_walnut;
      case "blue":
        return strings.shelving_blue;
    }
  },
  getThemeImage: (theme: ShelvingTheme) => {
    switch (theme) {
      case "cedar":
        return cedarImage;
      case "oak":
        return oakImage;
      case "ebony":
        return ebonyImage;
      case "walnut":
        return walnutImage;
      case "blue":
        return blueImage;
    }
  }
};
